import { Ifield } from '../types';
import { FormControl, FormHelperText } from '@mui/material';
import { getErrorText, isValid } from '..';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { useAppSelector } from 'hooks/redux.hooks';
import RadioSelector from 'components/FormElements/RadioSelector';

type props = {
	valid: boolean;
	cField: Ifield;
	initialValidation: any;
	handleChange: any;
};

export default function Radio(props: props) {
	const t = useAppSelector(selectTranslations);
	const { cField } = props;
	const { name, value, label, options, helperText } = cField.props;

	return (
		<FormControl key={name} fullWidth sx={cField.styleObj}>
			<RadioSelector
				handleChange={props.handleChange}
				name={name}
				options={options || []}
				value={value}
				label={label || ''}
			/>
			<FormHelperText>
				{isValid(props.initialValidation, cField.props.name)
					? t(getErrorText(props.initialValidation, cField.props.name))
					: helperText}
			</FormHelperText>
		</FormControl>
	);
}
